module.exports = __webpack_public_path__ + "img/shutterstock_490419343.861b87bc.jpg";